import React, { useMemo, useState } from 'react';
import { useManagerStore } from '../../../lib/store-manager';
import { SalesCoachBot } from '../../dashboard/SalesCoachBot';
import { PerformanceSummary } from './PerformanceSummary';
import { PastReportsModal } from './PastReportsModal';

interface PersonnelDetailProps {
    onBack: () => void;
}

export const PersonnelDetail: React.FC<PersonnelDetailProps> = ({ onBack }) => {
    const { activePersonnel, activePersonnelReports } = useManagerStore();
    const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);

    const stats = useMemo(() => {
        if (!activePersonnelReports || activePersonnelReports.length === 0) return null;

        const totalScore = activePersonnelReports.reduce((acc, r) => acc + (r.score || 0), 0);
        const avgScore = Math.round(totalScore / activePersonnelReports.length);

        return {
            avgScore,
            simulationCount: activePersonnelReports.length,
        };
    }, [activePersonnelReports]);

    if (!activePersonnel) return null;

    return (
        <div className="manager-view personnel-detail">
            {isHistoryModalOpen && (
                <PastReportsModal
                    reports={activePersonnelReports}
                    onClose={() => setIsHistoryModalOpen(false)}
                />
            )}

            <div className="action-bar" style={{ justifyContent: 'space-between', gap: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                        <span className="material-symbols-outlined">arrow_back</span>
                    </button>
                    <div>
                        <h1 style={{ margin: 0 }}>{activePersonnel.full_name}</h1>
                        <span style={{ fontSize: '14px', color: '#6b7280' }}>Personel Detayı</span>
                    </div>
                </div>

                <button
                    className="btn-secondary"
                    onClick={() => setIsHistoryModalOpen(true)}
                    style={{
                        padding: '10px 16px', background: 'white', border: '1px solid #d1d5db', borderRadius: '8px',
                        display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 500, color: '#374151'
                    }}
                >
                    <span className="material-symbols-outlined">history_edu</span>
                    Geçmiş Raporları Oku
                </button>
            </div>

            <div className="detail-grid" style={{ display: 'grid', gridTemplateColumns: 'minmax(400px, 1fr) 350px', gap: '24px', height: 'calc(100vh - 140px)' }}>
                {/* Left Column: Summary & Text-Based Emotion Analysis */}
                <div className="left-col" style={{ display: 'flex', flexDirection: 'column', gap: '24px', overflowY: 'auto', paddingRight: '8px' }}>

                    {/* Top Stats Row */}
                    <div className="stats-row" style={{ display: 'flex', gap: '24px' }}>
                        <div className="content-card stats-card" style={{ borderLeft: '4px solid #4f46e5', flex: 1 }}>
                            <h3 style={{ color: '#6b7280', fontSize: '14px' }}>Genel Satış Puanı</h3>
                            <div className="score" style={{ fontSize: '36px', fontWeight: '700', color: '#111827', display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                {stats ? stats.avgScore : '-'}
                                <span style={{ fontSize: '16px', color: '#9ca3af', fontWeight: '400' }}>/100</span>
                            </div>
                        </div>
                        <div className="content-card stats-card" style={{ borderLeft: '4px solid #10b981', flex: 1 }}>
                            <h3 style={{ color: '#6b7280', fontSize: '14px' }}>Toplam Simülasyon</h3>
                            <div className="score" style={{ fontSize: '36px', fontWeight: '700', color: '#111827' }}>
                                {stats ? stats.simulationCount : 0}
                            </div>
                        </div>
                    </div>

                    {/* AI Daily Summary & Emotional Analysis */}
                    <div className="content-card" style={{ flex: 1 }}>
                        <PerformanceSummary userId={activePersonnel.id} />
                    </div>
                </div>

                {/* Right Column: Embedded Chatbot */}
                <div className="right-col" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="content-card" style={{ flex: 1, padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ padding: '16px', borderBottom: '1px solid #e5e7eb', background: '#f8fafc' }}>
                            <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span className="material-symbols-outlined" style={{ color: '#4f46e5' }}>smart_toy</span>
                                SaTo: Personel Analizi
                            </h3>
                            <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#6b7280' }}>
                                {activePersonnel.full_name} hakkında koçunuzla sormak istediklerinizi konuşun.
                            </p>
                        </div>
                        <div style={{ flex: 1, position: 'relative' }}>
                            <SalesCoachBot
                                embedded={true}
                                targetUserId={activePersonnel.id}
                                targetUserName={activePersonnel.full_name}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
